import { useQuery } from '@apollo/client/react';

import { capitalizeLabel } from '@components/Basket/capitalizeLabel';
import { formattedEnergy } from '@features/details/Basket/formatter';
import { ProductType } from '@generated/gql/graphql';
import { thankYouQuery } from '@pages/ThankYou/query';
import { useBasketContext } from '@providers/basket/BasketProvider/Context';
import { getIsLoadingQuery } from '@utils/getIsLoadingQuery';

const useThankYouTariffSummary = () => {
  const { basketId } = useBasketContext();

  const { data, networkStatus, error } = useQuery(thankYouQuery, {
    variables: { basketId },
    skip: !basketId,
  });

  const energy =
    data?.basket?.selectedQuotes?.filter(
      (quote) => quote.product.type === ProductType.Energy
    ) || [];

  const formattedEnergyData = formattedEnergy(energy);

  return {
    basketId,
    isLoading: getIsLoadingQuery(networkStatus, data),
    hasError: !!error,
    tariffTitle: capitalizeLabel(formattedEnergyData?.charges?.[1] ?? ''),
    tariffSubtitle: capitalizeLabel(formattedEnergyData?.charges?.[0] ?? ''),
    price: formattedEnergyData?.total,
    hasData: !!formattedEnergyData,
  };
};

export { useThankYouTariffSummary };
